import { EXAMPLE_RESPONSE } from '../../until/constant'
import axiosClient from '../axiosClient'
import { EndPoint } from '../endpoint'

class Invoice {
  getListInvoices = async (params: any) => {
    const url = `${EndPoint.invoice}/list`
    const res = await axiosClient.get(url, { params })
    return res.data?.data || EXAMPLE_RESPONSE
  }

  print= async () => {
    const url = `/${EndPoint.invoice}/print`
    const res = await axiosClient.get(url)
    return res.data
  }
}

export const InvoiceManagerApi = new Invoice()
